import React from "react";

import ViewAppBar from "../views/ViewAppBar";

import styled from "styled-components";

import ViewFooter from "../views/ViewFooter";
import ViewInfoEmpreendimentos from "../views/ViewInfoEmpreendimentos";

const ContainerComponente = styled.div`
  width: 100%;
  min-height: 100vh; /* Garante que ocupa 100% da altura da viewport */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between; /* Isso garante que o conteúdo se ajusta */
  background-color: #f0f4f7;

  @media (max-width: 768px) {
    padding: 10px;
  }

  @media (max-width: 480px) {
    padding: 5px;
  }
`;

const InfoEmpreendimento: React.FC = () => (
  <ContainerComponente>
    <ViewAppBar />
    <ViewInfoEmpreendimentos />
    <ViewFooter />
  </ContainerComponente>
);
export default InfoEmpreendimento;
